// Analytics utility to handle all tracking events
export const trackEvent = (eventName, parameters = {}) => {
  // Facebook Pixel tracking
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, parameters);
      console.log('FB Pixel tracked:', eventName, parameters);
    } catch (error) {
      console.error('FB Pixel tracking error:', error);
    }
  }

  // Google Analytics tracking
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', eventName, parameters);
      console.log('GA tracked:', eventName, parameters);
    } catch (error) {
      console.error('GA tracking error:', error);
    }
  }

  // Microsoft Clarity tracking
  if (typeof window !== 'undefined' && window.clarity) {
    try {
      window.clarity('event', eventName);
      console.log('Clarity tracked:', eventName);
    } catch (error) {
      console.error('Clarity tracking error:', error);
    }
  }
};

// Specific tracking functions for common events
export const trackFormSubmission = (formName, formData = {}) => {
  trackEvent('Lead', {
    content_name: formName,
    content_category: 'form_submission',
    ...formData
  });
};

export const trackButtonClick = (buttonName, buttonLocation = '') => {
  trackEvent('ButtonClick', {
    event_category: 'engagement',
    event_label: buttonName,
    button_location: buttonLocation
  });
};

export const trackPageView = (pageName) => {
  trackEvent('PageView', {
    page_title: pageName,
    page_location: window.location.href
  });
};

export const trackVideoPlay = (videoTitle) => {
  trackEvent('VideoPlay', {
    content_name: videoTitle,
    content_type: 'video'
  });
};

export const trackDownload = (fileName) => {
  trackEvent('Download', {
    content_name: fileName,
    content_type: 'document'
  });
};

export const trackOutboundClick = (url, linkText = '') => {
  trackEvent('OutboundClick', {
    link_url: url,
    link_text: linkText
  });
};

export const trackScheduling = (sessionType) => {
  trackEvent('Schedule', {
    content_name: sessionType,
    content_category: 'booking'
  });
};

// Initialize tracking on page load
export const initializeTracking = () => {
  // Track initial page view
  trackPageView(document.title);
  
  // Track scroll depth
  let maxScroll = 0;
  const trackScrollDepth = () => {
    const scrollPercent = Math.round(
      ((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100
    );
    
    if (scrollPercent > maxScroll) {
      maxScroll = scrollPercent;
      
      // Track scroll milestones
      if (scrollPercent >= 25 && maxScroll < 25) {
        trackEvent('ScrollDepth', { scroll_depth: 25 });
      } else if (scrollPercent >= 50 && maxScroll < 50) {
        trackEvent('ScrollDepth', { scroll_depth: 50 });
      } else if (scrollPercent >= 75 && maxScroll < 75) {
        trackEvent('ScrollDepth', { scroll_depth: 75 });
      } else if (scrollPercent >= 90 && maxScroll < 90) {
        trackEvent('ScrollDepth', { scroll_depth: 90 });
      }
    }
  };

  window.addEventListener('scroll', trackScrollDepth, { passive: true });
};